import * as angular from "angular";

const transactionTypes = [
  'Collection',
  'Payment',
  'Deposit'
];

const paymentTypes = [
  'CASH',
  'CREDIT_CARD',
  'COUPON'
];

angular
  .module('bringoz.admin.wallets')
  .constant('WalletsConstants', {
    transactionTypes: transactionTypes,
    paymentTypes: paymentTypes
  });

